import * as React from "react"

type NavigationModel = {
    getItemsCount: () => number

    setSelectedIndex: (idx: number) => void
    getSelectedIndex: () => number // zero-based

    onRight?: () => void,
    onLeft?: () => void
}

const stop = (e: Event) => { e.stopPropagation(); e.preventDefault(); }

export default class KeyboardNavigation {
    private _model: NavigationModel;

    constructor(model: NavigationModel) {
        this._model = model;
    }

    onKeyDown(e: KeyboardEvent) {
        if (e.key === "ArrowUp") {
            this.up()
            stop(e)
        }
        else if (e.key === "ArrowDown") {
            this.down();
            stop(e)
        }
        else if (e.key === "PageUp") {
            this._changeIndex(this._model.getSelectedIndex() - 25)
            stop(e)
        }
        if (e.key === "PageDown") {
            this._changeIndex(this._model.getSelectedIndex() + 25)
            stop(e)
        }
        else if (e.key === "Home") {
            this._changeIndex(0)
            stop(e)
        }
        if (e.key === "End") {
            this._changeIndex(this._model.getItemsCount() -1)
            stop(e)
        }
        if (e.keyCode === 74) { // j
            if (!maxkir.is_text_input(e.target)) {
                this.down();
                stop(e)
            }
        }
        if (e.keyCode === 75) { // k
            if (!maxkir.is_text_input(e.target)) {
                this.up();
                stop(e)
            }
        }
        if (e.key === "ArrowRight") {
            const canRight = !maxkir.is_text_input(e.target) ||
                (typeof e.target["value"] !== "undefined" &&
                    e.target["value"].length === maxkir.get_selection_range(e.target as Element)[1]);
            if (canRight) {
                this._model.onRight();
                stop(e)
            }
        }
        if (e.key === "ArrowLeft") {
            const canLeft = !maxkir.is_text_input(e.target) ||
                (typeof e.target["value"] !== "undefined" && 0 === maxkir.get_selection_range(e.target as Element)[0]);
            if (canLeft) {
                this._model.onLeft();
                stop(e)
            }
        }
    }

    up() {
        this._changeIndex(this._model.getSelectedIndex() - 1)
    }

    down() {
        this._changeIndex(this._model.getSelectedIndex() + 1)
    }

    private _changeIndex(newValue: number) {
        const that = this;
        setTimeout(() => {
            let val = newValue
            if (val < 0) {
                val = 0;
            }
            if (val > that._model.getItemsCount() - 1) {
                val = that._model.getItemsCount() - 1
            }
            if (val >= 0) {
                that._model.setSelectedIndex(val)
            }
        }, 1)
    }
}